<template>
    <div id="content-agency" class="container">
        <div>
            <div class="block block_1">
                <div>
                    <h1>
                        <span>{{ $t("message.page_agency.block_1.title") }}</span>
                        <img src="@/assets/img/agency/underline_02.png" alt="" />
                    </h1>
                    <div v-html="$t('message.page_agency.block_1.content')" class="content"></div>
                </div>
                <div>
                    <img src="@/assets/img/agency/img_01.png" alt="" />
                </div>
            </div>

            <div class="block block_2">
                <div>
                    <img src="@/assets/img/agency/img_02.png" alt="" />
                </div>
                <div>
                    <h1>
                        <span>{{ $t("message.page_agency.block_2.title") }}</span>
                        <img src="@/assets/img/agency/underline_02.png" alt="" />
                    </h1>
                    <div v-html="$t('message.page_agency.block_2.content')" class="content"></div>
                </div>
            </div>

            <div class="block block_3">
                <div>
                    <h1>
                        <span>{{ $t("message.page_agency.block_3.title") }}</span>
                        <img src="@/assets/img/agency/underline_02.png" alt="" />
                    </h1>
                    <div v-html="$t('message.page_agency.block_3.content')" class="content"></div>
                </div>
                <div>
                    <img src="@/assets/img/agency/img_03.png" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContentAgency",
    data() {
        return {};
    },
    components: {},

    mounted() {
        let _this = this;
    },
    methods: {
        isItMobile() {},
    },
};
</script>

<style lang="scss" scoped>
#content-agency {
    position: relative;
    background-color: #1e1e3b;
    color: #fff;
    padding-bottom: 8rem;

    > div {
        margin: 0 auto;
        max-width: 1400px;
        width: 100%;
    }

    .block {
        display: flex;

        > div {
            flex: 1;
            box-sizing: border-box;

            img {
                max-width: 100%;
            }

            &:first-child {
                padding-right: 1rem;
            }

            &:last-child {
                padding-left: 1rem;
            }
        }

        h1 {
            display: flex;
            flex-direction: column;
            font-family: Oswald, sans-serif;
            font-weight: 600;
            font-size: 1.6rem;
            margin: 0;

            img {
                align-self: flex-start;
                margin-top: 1rem;
            }
        }

        .content {
            font-weight: 100;
            font-size: 1.2rem;
        }

        &.block_1 {
            padding-top: 3rem;

            h1,
            .content {
                max-width: 600px;
            }
        }

        &.block_2 {
            h1,
            .content {
                max-width: 400px;
                justify-self: center;
            }
        }

        &.block_3 {
            padding-top: 3rem;

            h1,
            .content {
                max-width: 400px;
            }
        }
    }
}

// WIDTH
@media (max-width: 1400px) {
}

@media (max-width: 1200px) {
    #content-agency {
        padding-bottom: 5rem;
    }
}

@media (max-width: 992px) {
    #content-agency {
        padding-bottom: 0;
    }
}

@media (max-width: 768px) {
    #content-agency {

        .block {
            flex-direction: column;
            padding: 2rem 0;

            > div:first-child,
            > div:last-child {
                padding-left: 0;
                padding-right: 0;
            }

            h1 {
                font-size: 1.4rem;
            }

            .content {
                font-size: 1rem;
            }

            &.block.block_1,
            &.block.block_2,
            &.block.block_3 {
                h1 {
                    max-width: 100%;
                }

                .content {
                    font-size: 1rem;
                    max-width: 100%;
                }
            }

            &.block.block_2 {
                flex-direction: column-reverse;
            }

            > div img {
                max-width: 400px;
                margin: auto;
                display: block;
                margin-top: 1rem;
            }
        }
    }
}

@media (max-width: 576px) {
    #content-agency {
        .block {
            h1 {
                font-size: 1.2rem;
            }

            > div img {
                max-width: 300px;
                margin: auto;
                display: block;
                margin-top: 1rem;
            }
        }
    }
}
</style>
